import React from 'react'
import Contact from './Contact'
import Footer from './Footer'

export default function Contactus() {
  return (
    <div>
      <Contact></Contact>
      <Footer></Footer>
    </div>
  )
}
